// frontend/src/components/reports/ReportFilters.js
import React, { useState } from "react";

const ReportFilters = ({ onChange }) => {
  const [status, setStatus] = useState("");
  const [priority, setPriority] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const applyFilters = (e) => {
    e.preventDefault();
    const filters = {
      status,
      priority,
      from_date: fromDate || undefined,
      to_date: toDate || undefined,
    };
    onChange(filters);
  };

  const clearFilters = (e) => {
    e?.preventDefault();
    setStatus("");
    setPriority("");
    setFromDate("");
    setToDate("");
    onChange({});
  };

  return (
    <>
      {/* the CSS expects: .report-filters form { display: grid; ... } */}
      <form onSubmit={applyFilters} className="report-filters-form">
        <div>
          <label htmlFor="status">Status</label>
          <select
            id="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="form-control"
          >
            <option value="">All</option>
            <option value="Pending">Pending</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Closed">Closed</option>
          </select>
        </div>

        <div>
          <label htmlFor="priority">Priority</label>
          <select
            id="priority"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            className="form-control"
          >
            <option value="">All</option>
            <option value="High">High</option>
            <option value="Medium">Medium</option>
            <option value="Low">Low</option>
          </select>
        </div>

        <div>
          <label htmlFor="fromDate">From</label>
          <input
            id="fromDate"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="form-control"
          />
        </div>

        <div>
          <label htmlFor="toDate">To</label>
          <input
            id="toDate"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="form-control"
          />
        </div>

        {/* Buttons area: uses classes in reports.css (.apply-btn, .clear-btn) */}
        <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
          <button type="submit" className="apply-btn">
            🔍 Apply
          </button>
          <button type="button" onClick={clearFilters} className="clear-btn">
            ✖️ Clear
          </button>
        </div>
      </form>
    </>
  );
};

export default ReportFilters;
